import { render, staticRenderFns } from "./EmailSmsLogListSideMenu.vue?vue&type=template&id=588375ce&scoped=true"
import script from "./EmailSmsLogListSideMenu.vue?vue&type=script&lang=js"
export * from "./EmailSmsLogListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./EmailSmsLogListSideMenu.vue?vue&type=style&index=0&id=588375ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588375ce",
  null
  
)

export default component.exports